
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"23","height":"3","rx":"1.5"}}),_c('rect',{attrs:{"x":".5","y":"7","width":"23","height":"3","rx":"1.5"}}),_c('rect',{attrs:{"x":".5","y":"13.5","width":"23","height":"3","rx":"1.5"}}),_c('rect',{attrs:{"x":".5","y":"20","width":"23","height":"3","rx":"1.5"}})])
          )
        }
      }
    